module.exports = __webpack_public_path__ + "static/media/download.122e6fcf.svg";